import { cn } from "@/utils";
import { useDroppable } from "@dnd-kit/core";
import React, { useMemo } from "react";
import { dragActiveHasCanvas } from "./handlers/workspaceDetailDrop";
import { destinationFor, droppableId, type DroppableData } from "./ids";
import { cnTransferDropTargetSurface } from "./transferDropTargetStyles";

interface FolderDropTargetProps {
  folderPath: string;
  workspaceId: string;
  children: React.ReactNode;
  className?: string;
}

export function FolderDropTarget({
  folderPath,
  workspaceId,
  children,
  className,
}: FolderDropTargetProps) {
  const droppableData = useMemo((): DroppableData => {
    return {
      surface: "workspace-folder",
      destination: destinationFor("workspace-folder", {
        workspaceId,
        parentPath: folderPath,
      }),
    };
  }, [workspaceId, folderPath]);

  const { setNodeRef, isOver, active } = useDroppable({
    id: droppableId.workspaceFolder(workspaceId, folderPath),
    data: droppableData,
  });

  const disallowed = isOver && dragActiveHasCanvas(active);

  return (
    <div
      ref={setNodeRef}
      className={cnTransferDropTargetSurface({
        isOver,
        disallowed,
        className: cn("rounded-2xl", className),
      })}
    >
      {children}
    </div>
  );
}
